(ns minorodata.components.ace-editor.core
  (:require ["react-ace" :default react-ace]
            ["ace-builds/src/ace" :as ace]
            ["ace-builds/src/mode-json"]
            ["ace-builds/src/mode-pgsql"]
            ["ace-builds/src/theme-dracula.js"]))


;; https://github.com/securingsincity/react-ace/blob/master/docs/Ace.md
(def defaults
  {:name                        "ace-editor"
   :placeholder                 nil
   :mode                        "json"
   :theme                       "dracula"
   :default-value               ""
   :height                      "300px"
   :width                       "100%"
   :class-name                  nil
   :font-size                   14
   :show-gutter                 true
   :show-print-margin           true
   :highlight-active-line       true
   :focus                       false
   :cursor-start                1
   :wrap-enabled                true
   :read-only                   false
   :min-lines                   nil
   :max-lines                   nil
   :enable-basic-autocompletion true
   :enable-live-autocompletion  true
   :enable-snippets             false
   :tab-size                    4
   :debounce-change-period      nil
   :on-load                     nil
   :on-before-load              nil
   :on-change                   nil
   :on-copy                     nil
   :on-paste                    nil
   :on-selection-change         nil
   :on-cursor-change            nil
   :on-focus                    nil
   :on-blur                     nil
   :on-input                    nil
   :on-scroll                   nil
   :on-validate                 nil
   :editor-props                {}
   :set-options                 {:useWorker false}
   :keyboard-handler            ""
   :commands                    []
   :annotations                 []
   :markers                     []
   :style                       {}
   :useWorker                   false})


(defn editor [props]
  [:> react-ace
   (merge
     defaults
     (dissoc props :completions))])
